// extracted by mini-css-extract-plugin
module.exports = {"queueTutorialModal":"_3x5SS5","tutorial":"_2k1o_r","exitButton":"WkNVr8","image":"_26Tl2X","buttons":"_62TtDx"};